import React from 'react';
import { ClaroModalCardLoader } from "@claropay/shared";
import { connect } from 'react-redux';
import styled from 'styled-components';

const SrOnly = styled.span`
	position: absolute;
	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	border: 0;
`;

const ModalCardLoader = ({ isOpen, bundleIdURL }) => {
    const [loaderImage, setLoaderImage] = React.useState("");

    React.useEffect(() => {
        setLoaderImage(
            bundleIdURL && (bundleIdURL === "com.telcel.contenedor.uat" || bundleIdURL === "com.telcel.contenedor")
                ? "/images/ClaroPayLoadingBlanco2.gif"
                : "https://logos.claropay.com/ClaroPayLoading2.gif"
        )        
    },[]);

    return(
        <>
            {
                isOpen &&
                <div role='status' aria-live='polite' id='modalLoader'>
                    <SrOnly>
                        Cargando información, Por favor espera
                    </SrOnly>
                    {loaderImage &&
                        <ClaroModalCardLoader
                            boxShadow="none!important"
                            backgroundColor="rgba(0,0,0,0.65)"
                            heightLoader="150px"
                            isOpen={isOpen}
                            srcImage={loaderImage}
                            widthLoader="150px"
                        />
                    }
                </div> 
            }
        </>
    )
}

const mapStateToProps = (state) => {
    const { payments } = state;

    return {
        bundleIdURL: payments.bundleId
    }
}

export default connect(mapStateToProps)(ModalCardLoader);